import React from 'react';
import { Typography, Card } from '@mui/material';

const ExternalSummaryCard = (props) => {
  const {
    monthlyQuotaAllotted,
    monthlyQuotaAvailed,
    title = 'External Hours Quota',
  } = props;

  return (
    <Card variant="outlined" className="external-card" sx={{ marginTop: 2 }}>
      <div className="external-stat-header" style={{ textAlign: 'center' }}>
        <h5 style={{ fontWeight: 'bold' }}>{title}</h5>
      </div>

      <div className="leave-stat-container">
        <div className="leave-number available-leave">
          <Typography align="center" component="div">
            {monthlyQuotaAllotted}
          </Typography>
        </div>
        <div className="leave-stats">Entitled</div>
      </div>

      <div className="leave-stat-container">
        <div className="leave-number used-leave">
          <Typography align="center" component="div">
            {monthlyQuotaAvailed}
          </Typography>
        </div>
        <div className="leave-stats">Availed</div>
      </div>
    </Card>
  );
};

export default ExternalSummaryCard;
